import { Component, signal, input, output } from '@angular/core';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTableModule } from 'ng-zorro-antd/table';
import { AngularModule } from '../../../../../modules/angular.module';
import { SectionStudentEnrollment } from '@mira-avant/mtlibs';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { DisplayNamePipe } from '../../../../../pipes/display-name.pipe';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NavigationService } from '../../../../../services/navigation.service';
import { AuthService } from '../../../../../services/auth.service';

@Component({
	selector: 'app-enrollment-table',
	imports: [
		AngularModule,
		NzTableModule,
		NzEmptyModule,
		NzPaginationModule,
		NzPopconfirmModule,
		NzButtonModule,
		NzIconModule,
		NzCheckboxModule,
		DisplayNamePipe,
		NzSpinModule,
	],
	standalone: true,
	templateUrl: './enrollment-table.html',
	styleUrl: './enrollment-table.scss',
})
export class EnrollmentTable {
	public enrollment = input<SectionStudentEnrollment[]>([], { alias: 'enrollment' });
	public loading = input<boolean>(false, { alias: 'loading' });
	public onSaveEnrollment = output<SectionStudentEnrollment[]>({ alias: 'onSaveEnrollment' });
	public enrollmentData = signal<SectionStudentEnrollment[]>([]);
	public isAdmin = signal<boolean>(false);

	constructor(
		public nav: NavigationService,
		private authService: AuthService
	) {}

	ngOnInit(): void {
		this.authService.isAdmin$().then(admin => {
			this.isAdmin.set(admin);
		});
	}

	ngOnChanges(): void {
		this.enrollmentData.set([...this.enrollment()]);
	}

	public async saveEnrollment(): Promise<void> {
		this.onSaveEnrollment.emit(this.enrollmentData());
	}
}